module.exports = "/_next/static/images/902918fa81543f5f0483e83668b75c59-man-looking-up-smiling-xs@1x.jpg";